import React from 'react';
import { CircularProgress, createStyles, Modal, Theme } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";

interface Props {
  active: boolean
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }),
);

const SpinnerModal: React.FunctionComponent<Props> = (props) => {
  const classes = useStyles();

  return(
    <Modal
        open={props.active}
        className={classes.modal}
      >
      <CircularProgress />
    </Modal>
  )
};

export default SpinnerModal;
